import { useState, useEffect, useCallback } from "react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-grid.css";

export default function AgGridPaginatedTable({
  columns,
  perPage = 10,
  refreshCounter,
  getTableRows,
  rowSelection = "",
  onCellClicked = () => { },
  onRowClicked = () => { },
  onCellFocused = () => { },
}) {
  const [gridApi, setGridApi] = useState(null);
  const rowHeight = 38;
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  // const onGridReady = useCallback((params) => {
  //   // in this example, the CSS styles are loaded AFTER the grid is created,
  //   // so we put this in a timeout, so height is calculated after styles are applied.
  //   setTimeout(function () {
  //     setGridApi(params.api);
  //   }, 500);
  // }, []);

  useEffect(() => {
    if (gridApi) {
      const dataSource = {
        getRows: async (params) => {
          gridApi.showLoadingOverlay();
          const { rows, total, error } = await getTableRows(
            perPage,
            params.endRow - perPage
          );
          gridApi.hideOverlay();
          if (error) {
            params.successCallback([], 0);
          } else {
            params.successCallback(rows, parseInt(total));
          }
        },
      };
      gridApi.setDatasource(dataSource);
    }
  }, [gridApi, refreshCounter]);

  return (
    //<div aria-live="polite" style={{width:"100%", height:"450px"}} aria-busy={false} className="ag-theme-material">
    <div
      aria-live="polite"
      style={{ height: "100%" }}
      aria-busy={false}
      className="ag-theme-material"
    >
      <AgGridReact
        columnDefs={columns}
        pagination={true}
        rowModelType="infinite"
        paginationPageSize={perPage}
        cacheBlockSize={perPage}
        // rowData={rowData}
        onGridReady={onGridReady}
        serverSideInfiniteScroll={true}
        defaultColDef={{
          resizable: true,
          flex: 1,
        }}
        domLayout="autoHeight"
        headerHeight="38"
        // rowHeight={rowHeight}
        rowSelection="single"
        onCellClicked={onCellClicked}
        onRowClicked={onRowClicked}
        onCellFocused={onCellFocused}
      />
    </div>
  );
}
